export const endpoints = {
  getMentorsOverview: (args) => {
    if (!args?.org || !args?.userId) return '/api/search/mentors/';

    return `/api/search/orgs/${args.org}/users/${args.userId}/mentors/`;
  },
};
